import React from 'react'
import { Box, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import useDocumentGenerate from 'hooks/useDocumentGenerate'

const FillVariableConfirmationDialog = ({
  open,
  setOpen,
  variables = [],
  variableValues = {},
}) => {
  const { handleNext } = useDocumentGenerate()

  const variablesWithValues = variables.map((variable) => ({
    ...variable,
    value: variableValues[variable.inputName] || '',
  }))

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Revise as informações para continuar"
      closeButtonText="Cancelar"
      actionButtonText="Gerar"
      actionButton={handleNext}
    >
      <Box mb={2}>
        <Typography variant="body1">
          Antes de gerar o documento, revise e confirme as informações
          preenchidas. A geração será feita com base nos dados informados até
          aqui.
        </Typography>
      </Box>

      {variablesWithValues.map((variable) => (
        <Typography key={variable.id} variant="body2" gutterBottom>
          <strong>{variable.name}:</strong> {variable.value || 'Não informado'}
        </Typography>
      ))}
    </BaseDialog>
  )
}

export default FillVariableConfirmationDialog
